import React from "react";
import { Star } from "lucide-react";

interface Props {
  nom: string;
  role: string;
  note: number;
  commentaire: string;
  avatar?: string;
}

const Temoignage: React.FC<Props> = ({ nom, role, note, commentaire, avatar }) => {
  return (
    <div className="carte-temoignage">
      <div className="etoiles">
        {Array.from({ length: 5 }).map((_, i) => (
          <Star key={i} className={i < note ? "etoile-remplie" : "etoile-vide"} />
        ))}
      </div>
      <p className="commentaire">{commentaire}</p>
      <div className="utilisateur">
        <img src={avatar || "/default-avatar.png"} alt={nom} className="avatar" />
        <div>
          <h4 className="nom">{nom}</h4>
          <p className="role">{role}</p>
        </div>
      </div>
    </div>
  );
};

export default Temoignage;
